import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { AlertLabel } from '../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import PickupPattern from '../../AirportTransferTaxi/TemporaryReservation/Form/PickupPattern';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

export interface Props {
  /** 警告の種別。 */
  type?: "retry" | "email" | "input" | "fail" | "address" | "unselected" | "retry_with_v2",
  /** 任意の警告メッセージを表示する */
  anyMessage?: AlertLabel[],
  pickupPattern?: PickupPattern
}

const useStyles = makeStyles(() => ({
  root: {
    marginTop: "10px"
  },
  notice: {
    marginTop: "10px",
    color: '#ff0000'
  }
}));

/** 警告の重要度を設定する。 */
function setSeverity(type: string) {
  switch(type) {
    // 再実行を促す警告の場合、黄色（warning）を設定する。
    case "retry":
      return "warning"
    // メールアドレスが利用できない場合/予約に失敗した場合/その他エラーの場合は赤色（error）を設定する。
    case "email":
    case "input":
    case "fail":
    default:
      return "error";
  }
}

/**
 * 警告で表示するメッセージを設定する。
 * @param type 警告の種別。
 */
function setMessage(type: string, t: TFunction, pickupPattern?: PickupPattern) {
  switch(type) {
    case "address":
      //const trasTypeStr = pickupPattern === PickupPattern.FROM_AIRPORT? t('taxi:sending_location'): t('taxi:pickup_location');
      return t('taxi:alert_message_address');
    case "unselected":
      return t('taxi:alert_message_unselected');
    case "retry":
      return t('taxi:alert_message_retry');
    case "email":
      return t('taxi:alert_message_email');
    case "input":
      return t('taxi:alert_message_input');
    case "retry_with_v2":
      return t('taxi:alert_message_retry_with_v2');
    case "fail":
    default:
      return t('taxi:alert_message_fail');
  }
}

/** タクシー予約時の警告メッセージ用のコンポーネント。 */
const AlertInReservation: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  let severity: any = "warning";
  if(props.type) {
    /** 警告の重要度。（この値に応じて警告の色・アイコンが変わる。） */
    severity = setSeverity(props.type);
    /** 警告で表示するメッセージ。 */
    const message = setMessage(props.type, t,props.pickupPattern);
    return (
      <Alert severity={severity} className={classes.root}>
        { message }
      </Alert>
    );
  }
  else if(props.anyMessage) {
    /** 任意の警告メッセージが復数ある場合には全てを表示する */
    return (
      <>
        {props.anyMessage.map((label, index)=>{
          if(label.type === 'alert') {
            return (
              <Alert severity={severity} className={classes.root} key={index}>
                { label.message }
              </Alert>
            )
          }
          else {
            return (
              <div className={classes.notice} key={index}>
                ※ { label.message }
              </div>
            )
          }
        })}
      </>
    )
  }
  return null;
}

export default AlertInReservation;
